/**
 * Common types for Augmented Chess Engine
 */

/** Files (columns) a-h */
export type File = "a" | "b" | "c" | "d" | "e" | "f" | "g" | "h";

/** Ranks (rows) 1-8 */
export type Rank = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;

/** Chess square position */
export interface Square {
  file: File;
  rank: Rank;
}

/** Player color */
export type Color = "WHITE" | "BLACK";

/** Standard chess piece types */
export type PieceType =
  | "KING"
  | "QUEEN"
  | "ROOK"
  | "BISHOP"
  | "KNIGHT"
  | "PAWN";

/** Piece types that a pawn can promote to */
export type PromotablePieceType = Exclude<PieceType, "KING" | "PAWN">;

/** Game phase */
export type GamePhase =
  | "AUGMENTATION_SELECTION"
  | "PLAYING"
  | "CHECKMATE"
  | "STALEMATE"
  | "DRAW"
  | "CONSECUTIVE_CHECK_WIN";

/** Validation result following standard engine interface */
export interface ValidationResult {
  readonly valid: boolean;
  readonly error?: string;
  readonly details?: Record<string, unknown>;
}

/** All files in order */
export const FILES: readonly File[] = [
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
] as const;

/** All ranks in order */
export const RANKS: readonly Rank[] = [1, 2, 3, 4, 5, 6, 7, 8] as const;
